/*
 *************************************************************************
 *  ADOBE CONFIDENTIAL
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 *************************************************************************
 */

/**
 * Mark timestamps using `window.performance.mark()`.
 *
 * All marks defined here will be reported in the performance-report event.
 */
export const PERFORMANCE_MARKS = {
	skeleton: 'skeleton',
	timeToHTML: 'timeToHTML',
	timeToNavHome: 'timeToNavHome', // To track the time when left nav/top nav is rendered on Home
	timeToNavApps: 'timeToNavApps', // To track the time when left nav/top nav is rendered on Apps
	timeToFullPageLoadHome: 'timeToFullPageLoadHome', // To track the time when Home is loaded
	timeToFullPageLoadApps: 'timeToFullPageLoadApps', // To track the time when Apps is loaded
	timeToResolveBlockingPromises: 'timeToResolveBlockingPromises', // To track the time when blocking promises are resolved
	timeToLoadFixedApplets: 'timeToLoadFixedApplets', // To track the time when fixed applets are loaded
	timeToLoadOptionalApplets: 'timeToLoadOptionalApplets', // To track the time when optional applets are loaded
	timeToLoadUNAV: 'timeToLoadUNAV', // To track the time when Universal Nav finishes initializing
	timeToLoadGNAVHeader: 'timeToLoadGNAVHeader', // To track the time when the GNAV header finishes loading
} as const;
